import React, { memo, useContext, useEffect, useReducer } from 'react';
import { useSnackbar } from 'notistack';
import PropTypes from 'prop-types';
import { NavLink, useHistory } from 'react-router-dom';
import './css/SmallGamesWidget1.css';
import { getFullDateStringFromDate, getLocalTimeFromDatabaseTime, getTimeInAMPMFromDate } from '../../../../catalog/DateTime';
import { context } from '../../../../globalState/GlobalState';
import { fetchLimitedPreviousGamesAPI, fetchLimitedScheduledGamesAPI } from '../../../apiCalls/games/GameAPICalls';
import { isValidObject, isValidString } from '../../../../catalog/Validity';
import demoOpponentTeam from '../../../../assets/demoOpponentTeam.png';
import { opponentGoalsFromGame as opponentIceHockeyGoalsFromGame, ourGoalsFromGame as ourIceHockeyGoalsFromGame } from '../../../../catalog/stats/iceHockey/IceHockeyGameStats';
import { opponentGoalsFromGame as opponentLacrosseGoalsFromGame, ourGoalsFromGame as ourLacrosseGoalsFromGame } from '../../../../catalog/stats/lacrosse/LacrosseGameStats';
import { SportsType } from '../../../../catalog/enums/SportsType';
import { opponentPointsFromGame, ourPointsFromGame } from '../../../../catalog/stats/rugby/RugbyGameStats';
import Spinner2 from '../../spinners/spinner2/Spinner2';
import { fetchTicketsByEventAPI } from '../../../apiCalls/TicketAPICalls';
import Button1 from '../../buttons/Button1';
import { showGameTickets } from '../../../../catalog/Store';
import Button3 from '../../buttons/Button3';

const initialState = {
    games: [],
    tickets: {},
    loadingSpinner: true,
};

function reducer(state, action) {
    switch (action.type) {
        case 'fetchGames':
            return { ...state, games: action.games };
        case 'fetchTickets':
            if (action.tickets.length > 0) {
                return { ...state, tickets: { ...state.tickets, [action.tickets[0].eventId]: action.tickets } };
            }
            return state;
        case 'fetchPreviousGames':
            return { ...state, games: action.games };
        case 'fetchScheduledGames':
            return { ...state, games: action.games };
        case 'setLoadingSpinner':
            return { ...state, loadingSpinner: action.loadingSpinner };
        default:
            return initialState;
    }
}

const SmallGamesWidget1 = (props) => {
    const { scheduled, whiteTitle } = props;
    const [state, setState] = useReducer(reducer, initialState);
    const { globalState } = useContext(context);
    const { enqueueSnackbar } = useSnackbar();
    const history = useHistory();

    useEffect(() => {
        async function fetchGames() {
            if (scheduled) {
                await fetchLimitedScheduledGamesAPI(globalState.accountId, 3, setState, enqueueSnackbar);
            } else {
                await fetchLimitedPreviousGamesAPI(globalState.accountId, 3, setState, enqueueSnackbar);
            }
            setState({ type: 'setLoadingSpinner', loadingSpinner: false });
        }
        fetchGames();
    }, []);

    useEffect(() => {
        async function fetchTickets() {
            if (isValidObject(globalState.accountId)) {
                state.games.map(async (game) => {
                    if (isValidString(game.id)) {
                        await fetchTicketsByEventAPI(globalState.accountId, game.id, setState, enqueueSnackbar);
                    }
                });
            }
        }
        fetchTickets();
    }, [state.games]);

    const getOurFinalScore = (game) => {
        if (game.status === 'postponed' || game.status === 'cancelled' || game.status === 'tba' || game.status === 'tbat' || game.status === 'scheduled') {
            return '';
        }
        if (globalState.sportsType === SportsType.WOMENSICEHOCKEY || globalState.sportsType === SportsType.MENSICEHOCKEY) {
            return ourIceHockeyGoalsFromGame(game);
        }
        if (globalState.sportsType === SportsType.WOMENSRUGBY || globalState.sportsType === SportsType.MENSRUGBY) {
            return ourPointsFromGame(game);
        }
        if (globalState.sportsType === SportsType.WOMENSLACROSSE || globalState.sportsType === SportsType.MENSLACROSSE) {
            return ourLacrosseGoalsFromGame(game);
        }
        return '';
    };

    const getOpponentFinalScore = (game) => {
        if (game.status === 'postponed' || game.status === 'cancelled' || game.status === 'tba' || game.status === 'tbat' || game.status === 'scheduled') {
            return '';
        }
        if (globalState.sportsType === SportsType.WOMENSICEHOCKEY || globalState.sportsType === SportsType.MENSICEHOCKEY) {
            return opponentIceHockeyGoalsFromGame(game);
        }
        if (globalState.sportsType === SportsType.WOMENSRUGBY || globalState.sportsType === SportsType.MENSRUGBY) {
            return opponentPointsFromGame(game);
        }
        if (globalState.sportsType === SportsType.WOMENSLACROSSE || globalState.sportsType === SportsType.MENSLACROSSE) {
            return opponentLacrosseGoalsFromGame(game);
        }
        return '';
    };

    const getMiddleText = (game) => {
        if (game.status === 'postponed') {
            return 'Postponed';
        } if (game.status === 'cancelled') {
            return 'Cancelled';
        } if (game.status === 'tba' || game.status === 'tbat' || game.status === 'scheduled') {
            return 'vs';
        }
        return '-';
    };

    const getGame = (game) => {
        return (
            <NavLink key={game.id} to={`/games/${game.id}`} className="game x-center m-t-10px m-b-10px text-black text-no-underline">
                <div className="game-date-league full-width">
                    <p className="font-size-xl m-t-0 m-l-0 m-r-0 m-b-0">{game.status === 'tba' ? 'TBA' : getFullDateStringFromDate(getLocalTimeFromDatabaseTime(game.timeOfGame))}</p>
                    <p className="font-size-xl m-t-0 m-l-0 m-r-0 m-b-0">{game.status === 'tbat' || game.status === 'tba' ? '' : getTimeInAMPMFromDate(getLocalTimeFromDatabaseTime(game.timeOfGame))}</p>
                </div>
                {!game.homeGame ? (
                    <div className="game-scorecard full-width m-b-5px">
                        <div className="game-scorecard-logo-container">
                            {isValidObject(globalState.logo) && isValidString(globalState.logo.logo2) ? (
                                <img className="game-scorecard-logo" src={globalState.logo.logo2} alt={globalState.teamAlias} />
                            ) : (
                                <p className="game-scorecard-logo text-right-align font-size-s m-t-0 m-l-0 m-b-0">{globalState.teamAlias}</p>
                            )}
                        </div>
                        <p className="game-scorecard-score font-size-2xl m-t-0 m-b-0 p-l-20px">
                            {getOurFinalScore(game)}
                        </p>
                        {showGameTickets(globalState, state.tickets[game.id], game.timeOfGame, scheduled) ? (
                            <Button3
                                title="Tickets"
                                backgroundColor={globalState.websiteStyles.colors.primaryColor}
                                fontColor={isValidString(globalState.websiteStyles.colors.fontColor) ? `${globalState.websiteStyles.colors.fontColor}` : 'white'}
                                borderColor={globalState.websiteStyles.colors.primaryColor}
                                fontSize="0.7rem"
                                borderRadius="4px"
                                width="100px"
                                height="25px"
                                onClick={(event) => {
                                    event.stopPropagation();
                                    event.preventDefault();
                                    history.push(`/games/${game.id}/tickets`);
                                }}
                            />
                        ) : (
                            <p className="font-size-2xl m-t-0 m-l-5px m-r-5px m-b-0">
                                {getMiddleText(game)}
                            </p>
                        )}
                        <p className="game-scorecard-score font-size-2xl m-t-0 m-b-0 p-r-20px">
                            {getOpponentFinalScore(game)}
                        </p>
                        <div className="game-scorecard-logo-container">
                            {isValidString(game.opponentLogo) ? (
                                <img className="game-scorecard-logo" src={game.opponentLogo} alt={game.opponentName} />
                            ) : (
                                <img className="game-scorecard-logo" src={demoOpponentTeam} alt={game.opponentName} />
                                // <p className="game-scorecard-logo text-left-align font-size-s m-t-0 m-r-0 m-b-0">{game.opponentName}</p>
                            )}
                        </div>
                    </div>
                ) : (
                    <div className="game-scorecard full-width m-b-5px">
                        <div className="game-scorecard-logo-container">
                            {isValidString(game.opponentLogo) ? (
                                <img className="game-scorecard-logo" src={game.opponentLogo} alt={game.opponentName} />
                            ) : (
                                <img className="game-scorecard-logo" src={demoOpponentTeam} alt={game.opponentName} />
                                // <p className="game-scorecard-logo text-right-align font-size-s m-t-0 m-l-0 m-b-0">{game.opponentName}</p>
                            )}
                        </div>
                        <p className="game-scorecard-score font-size-2xl m-t-0 m-b-0 p-l-20px">
                            {getOpponentFinalScore(game)}
                        </p>
                        {showGameTickets(globalState, state.tickets[game.id], game.timeOfGame, scheduled) ? (
                            <Button1
                                title="Tickets"
                                backgroundColor={globalState.websiteStyles.colors.primaryColor}
                                fontColor={isValidString(globalState.websiteStyles.colors.fontColor) ? `${globalState.websiteStyles.colors.fontColor}` : 'white'}
                                borderColor={globalState.websiteStyles.colors.primaryColor}
                                fontSize="0.7rem"
                                borderRadius="4px"
                                width="100px"
                                height="25px"
                                onClick={(event) => {
                                    event.stopPropagation();
                                    event.preventDefault();
                                    history.push(`/games/${game.id}/tickets`);
                                }}
                            />
                        ) : (
                            <p className="font-size-2xl m-t-0 m-l-5px m-r-5px m-b-0">
                                {getMiddleText(game)}
                            </p>
                        )}
                        <p className="game-scorecard-score font-size-2xl m-t-0 m-b-0 p-r-20px">
                            {getOurFinalScore(game)}
                        </p>
                        <div className="game-scorecard-logo-container">
                            {isValidObject(globalState.logo) && isValidString(globalState.logo.logo2) ? (
                                <img className="game-scorecard-logo" src={globalState.logo.logo2} alt={globalState.teamAlias} />
                            ) : (
                                <p className="game-scorecard-logo text-left-align font-size-s m-t-0 m-r-0 m-b-0">{globalState.teamAlias}</p>
                            )}
                        </div>
                    </div>
                )}
            </NavLink>
        );
    };

    return (
        <div className="small-games-widget1-container">
            <NavLink to={scheduled ? '/schedule/upcoming' : '/schedule/results'} className={whiteTitle ? 'alegreya-font-family font-weight-500 m-t-0 m-l-0 m-r-0 m-b-10px text-left-align font-size-m text-uppercase text-white text-no-underline' : 'alegreya-font-family font-weight-500 m-t-0 m-l-0 m-r-0 m-b-10px text-left-align font-size-m text-uppercase text-black text-no-underline'}>{scheduled ? 'Upcoming Games' : 'Results'}</NavLink>
            <div className="small-games full-width box-shadow-black curve-border-15px p-t-10px p-b-10px p-l-30px p-r-30px">
                {state.loadingSpinner ? (<Spinner2 color={globalState.websiteStyles.colors.primaryColor} marginTop={130} size={20} />) : (
                    <>
                        {state.games.length > 0 ? (
                            <>
                                {state.games.map((game) => {
                                    return (
                                        <React.Fragment key={game.id}>
                                            {getGame(game)}
                                        </React.Fragment>
                                    );
                                })}
                            </>
                        ) : (<p className="alegreya-font-family font-weight-500 font-size-3xl full-width text-center-align m-t-100px text-uppercase">{scheduled ? 'No Upcoming Games' : 'No Games Available'}</p>)}
                    </>
                )}
            </div>
        </div>
    );
};

SmallGamesWidget1.propTypes = {
    scheduled: PropTypes.bool,
    whiteTitle: PropTypes.bool,
};

SmallGamesWidget1.defaultProps = {
    scheduled: true,
    whiteTitle: false,
};

export default memo(SmallGamesWidget1);
